export default __webpack_public_path__ + "static/Preserving_Bin-b971d78991131717f5041d5e52d05691.png";